import request from "./request";

const api = {
  upload: "file/upload",
};
export default {
  upload(parameter) {
    return request({
      url: api.upload,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: parameter,
    });
  },
};
